import { useState, useEffect } from "react";
import { Checkbox, Loader, Message, useToaster } from "rsuite";
import { authCRUD } from "../../../../actions/auth";
import { selector } from "../../../../api";

export const UserRoles = (props) => {
  const { userId } = props;
  const user = selector.User();
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const toaster = useToaster();

  useEffect(() => {
    if (userId) {
      setLoading(true);
      setTimeout(() => {
        authCRUD
          .loadUserById(userId)
          .then((resp) => {
            setData(resp.data[0]);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [userId, index]);

  const handleActivateRole = (role) => {
    setLoading(true);
    setTimeout(() => {
      authCRUD.postUserRoleActivation(userId, role).then(() => {
        setLoading(false);
        setIndex(index + 1);
        toaster.push(
          <Message type="success" showIcon header={"Success"} closable>
            <p className="h6 fs-14">
              <span className="fw-bold">Thank You</span>
              <br />
              <span className="text-dark">
                Staff role has been changed successfully..!
              </span>
              .
            </p>
          </Message>,
          { placement: "bottomEnd", duration: 7000 }
        );
      });
    }, 500);
  };

  return (
    <>
      <div className="card shadow border-red p-3">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh", // Full viewport height
              overflow: "hidden",
            }}
          >
            <Loader
              backdrop
              size="md"
              speed="slow"
              content="Please wait..."
              vertical
            />
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-md-3 col-sm--12 mt-2">
                <p className="h6 fw-bold">Administrator</p>
              </div>
              <div className="col-md-1 col-sm--12 mt-2">
                <p className="h6 fw-bold">:</p>
              </div>
              <div className="col-md-6 col-sm--12">
                <Checkbox
                  color={data?.is_admin ? "green" : "red"}
                  checked={data?.is_admin}
                  onClick={() => handleActivateRole("admin")}
                />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3 col-sm--12 mt-2">
                <p className="h6 fw-bold">Student Verifier</p>
              </div>
              <div className="col-md-1 col-sm--12 mt-2">
                <p className="h6 fw-bold">:</p>
              </div>
              <div className="col-md-6 col-sm--12">
                <Checkbox
                  color={data?.is_data ? "green" : "red"}
                  checked={data?.is_data}
                  onClick={() => handleActivateRole("data")}
                />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3 col-sm--12 mt-2">
                <p className="h6 fw-bold">Card Printer</p>
              </div>
              <div className="col-md-1 col-sm--12 mt-2">
                <p className="h6 fw-bold">:</p>
              </div>
              <div className="col-md-6 col-sm--12">
                <Checkbox
                  color={data?.is_cordinator ? "green" : "red"}
                  checked={data?.is_cordinator}
                  onClick={() => handleActivateRole("cordinator")}
                />
              </div>
            </div>
            <hr />
          </>
        )}
      </div>
    </>
  );
};
